import { render, staticRenderFns } from "./LLAdd.vue?vue&type=template&id=f2671a08&"
import script from "./LLAdd.vue?vue&type=script&lang=js&"
export * from "./LLAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports